import { IconBase } from './IconBase'

type IconEmptyNewsProps = React.ComponentProps<'svg'>

export const IconEmptyNews = (props: IconEmptyNewsProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 160 160" {...props}>
      <path
        d="M143.333 36.667H133.333V136.667H143.333C147.017 136.667 150 133.684 150 130V43.3337C150 39.6503 147.017 36.667 143.333 36.667Z"
        fill="url(#paint0_linear_10037_60568)"
      />
      <path
        d="M136.667 130V29.9997C136.667 26.3163 133.683 23.333 130 23.333H16.6667C12.9833 23.333 10 26.3163 10 29.9997V130C10 133.683 12.9833 136.666 16.6667 136.666H143.333C139.65 136.666 136.667 133.683 136.667 130Z"
        fill="#5286FF"
      />
      <path
        d="M123.333 56.6663H23.3333C21.4933 56.6663 20 55.173 20 53.333V46.6663C20 44.8263 21.4933 43.333 23.3333 43.333H123.333C125.173 43.333 126.667 44.8263 126.667 46.6663V53.333C126.667 55.173 125.173 56.6663 123.333 56.6663Z"
        fill="white"
      />
      <path
        d="M63.3333 120H23.3333C21.4933 120 20 118.507 20 116.667V73.3333C20 71.4933 21.4933 70 23.3333 70H63.3333C65.1733 70 66.6667 71.4933 66.6667 73.3333V116.667C66.6667 118.507 65.1733 120 63.3333 120Z"
        fill="white"
      />
      <path
        d="M126.667 80H80V73.3333C80 71.4933 81.4933 70 83.3333 70H123.333C125.173 70 126.667 71.4933 126.667 73.3333V80Z"
        fill="white"
      />
      <path d="M126.667 80H80V90H126.667V80Z" fill="#E6EEFF" />
      <path d="M126.667 90H80V100H126.667V90Z" fill="#CCDCFF" />
      <path d="M126.667 100H80V110H126.667V100Z" fill="#B3CBFF" />
      <path
        d="M123.333 120H83.3333C81.4933 120 80 118.507 80 116.667V110H126.667V116.667C126.667 118.507 125.173 120 123.333 120Z"
        fill="#9ABAFF"
      />
      <rect
        x="10.3483"
        y="15.0625"
        width="6.66667"
        height="186.466"
        transform="rotate(-45 10.3483 15.0625)"
        fill="#1B1D2A"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10037_60568"
          x1="136.727"
          y1="86.667"
          x2="150.587"
          y2="86.667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3537B0" />
          <stop offset="1" stopColor="#4646CF" />
        </linearGradient>
      </defs>
    </IconBase>
  )
}
